import { Box, Typography } from '@mui/material'
import { sectionTitleSx } from '../styles'

interface CommentsSectionProps {
  comments: string | null | undefined
}

export const CommentsSection = ({ comments }: CommentsSectionProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={sectionTitleSx}>Full Comments</Typography>
      <Box
        sx={{
          mt: 1,
          p: 1.5,
          backgroundColor: 'background.default',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            fontSize: '0.8rem',
            lineHeight: 1.5,
            color: 'text.primary',
            whiteSpace: 'pre-wrap',
          }}
        >
          {comments}
        </Typography>
      </Box>
    </Box>
  )
}
